
import { Component, Prop, Vue } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";

@Component({
  components: { LogTable },
})

export default class UserLogsTab extends Vue {

  @Prop({ default: null })
  public userId: number;

  private logs: any = [];
  private loading: boolean = false;

  private getLogs(params?: any) {
    if (this.userId) {
      this.loading = true;
      this.$store.dispatch("logs/getLogs", {
        query: {
          currentPage: "user",
          entityId: this.userId,
          entityType: "user",
          ...params,
        },
      }).then((res) => {
        this.logs = res;
      }).finally(() => {
        this.loading = false;
        this.$emit("loaded");
      });
    }
  }
}
